import { fecha, type Idioma, type useTraduccion } from '@tallerya/i18n';
import type { FichaItem } from './datos';

/**
 * La línea de datos bajo el título de un ítem: «SRV-0002 · Frenos · Creado el 2
 * sep 2026 · Última modificación: hoy por Vladimir Orellana». La usan la edición
 * (#113) y la ficha (#157). Son datos que se leen siempre, así que van en
 * `descripcion` y no tras el ⓘ (#120).
 *
 * `categoria` es el nombre ya resuelto: la ficha trae el id y la lista de
 * categorías, el nombre. Sin ella, la línea no la menciona.
 */
export function encabezado(
  ficha: FichaItem,
  idioma: Idioma,
  t: ReturnType<typeof useTraduccion>['t'],
  categoria?: string,
): string {
  const cuando = (valor: string) =>
    new Date(valor).toDateString() === new Date().toDateString()
      ? t('admin.catalogo.formulario.hoy')
      : fecha(valor, idioma);

  const modificado = ficha.updatedBy
    ? t('admin.catalogo.formulario.modificadoPor', { fecha: cuando(ficha.updatedAt), autor: ficha.updatedBy })
    : t('admin.catalogo.formulario.modificado', { fecha: cuando(ficha.updatedAt) });

  return [ficha.code, categoria, t('admin.catalogo.formulario.creado', { fecha: fecha(ficha.createdAt, idioma) }), modificado]
    .filter(Boolean)
    .join(' · ');
}
